const customElementsName = 'popup-component';

!window.customElements.get(customElementsName) &&
window.customElements.define(customElementsName, class extends HTMLElement{
  constructor(){
    super();
    this.isOpen = false;

    this.config = {
      activeClass: 'active',
      bodyClass: ['show-popup', 'overflow-hidden']
    }

    if(this.hasAttribute('data-body-class')){
      this.config.customBodyClass = this.getAttribute('data-body-class').split(',');
    }
  }

  connectedCallback(){

    this.addEventListener('click', e=>{
      const currentTarget = e.target;

      if(!currentTarget.closest('.popup-content') || currentTarget.closest('.jsClose')){
        this.close();
        e.stopPropagation();
      }
    });

    this.autoAppend();
    this.autoShow();
  }

  close(){
    this.classList.remove(this.config.activeClass);
    
    if(this.config.customBodyClass)
      document.body.classList.remove(...this.config.customBodyClass);


    const visibilityCheck = ()=>{
      const isVisible = window.getComputedStyle(this).opacity;

      if(isVisible != '0')
        requestAnimationFrame(visibilityCheck)
      else{
        this.setAttribute('aria-hidden', true);
        this.isOpen = false;

        document.querySelectorAll(`.jsTogglePopup[data-control="#${this.id}"]`)?.forEach(el => el.classList.remove('active'));

        if(Array.from(document.querySelectorAll('popup-component')).some(i=>i.isOpen == true)) return;

        document.body.classList.remove(...this.config.bodyClass);
      }
    }

    requestAnimationFrame(visibilityCheck);
  }

  open(callback = null){
    this.classList.add(this.config.activeClass);
    
    document.body.classList.add(...this.config.bodyClass);
    
    if(this.config.customBodyClass)
      document.body.classList.add(...this.config.customBodyClass);

    const visibilityCheck = ()=>{
      const isVisible = window.getComputedStyle(this).opacity;

      if(isVisible != '0'){
        this.isOpen = true;
        this.setAttribute('aria-hidden', false);
        this.autoHide();

        setTimeout(()=>{
          this.querySelector('[autofocus]')?.focus();
        }, 100)

        callback && callback();
      }
      else{
        requestAnimationFrame(visibilityCheck)
      }
    }

    requestAnimationFrame(visibilityCheck);

  }

  autoAppend(){
    if (!this.hasAttribute("auto-append")) return;

    this.removeAttribute("auto-append");

    const existingNode = document.getElementById(this.id);

    if (existingNode && existingNode !== this) {
      existingNode.after(this);
      existingNode.remove();
    }
  }

  autoShow(){
    if (!this.hasAttribute("auto-show")) return;

    this.removeAttribute("auto-show");
    setTimeout(()=>{
      this.open();
    }, 300);
  }

  autoHide(){
    if (!this.hasAttribute("auto-hide")) return;
    if(this.isHiding != null)
      clearTimeout(this.isHiding)

    this.isHiding = setTimeout(()=>{
      this.close();
      this.isHiding = null;
    }, +this.getAttribute('auto-hide'));
  }
});


document.querySelectorAll('.jsTogglePopup').forEach(ele=>{
    ele.addEventListener('click',(e)=>{
        e.preventDefault();
        let { control: popupControlId, id: popupId, action  } = ele.dataset;
        let popup = null;
        if(popupControlId) popup = document.querySelector(`.popup-component[data-control="${popupControlId}"],${popupControlId}`);
	    else if(popupId) popup = document.querySelector(`.popup-component[id="${popupId}"],${popupId}`);
        if (!popup) return;
        popup.classList.add('active');
    })
})
document.querySelectorAll('.jsPopupClose').forEach(ele=>{
    ele.addEventListener('click',(e)=>{
        e.preventDefault();
        const popup = el.closest('.popup-component');
	    if (!popup) return;
        popup.classList.remove('active');
    })
})

document.addEventListener('DOMContentLoaded',()=>{
  if (window.location.href.includes('contact_posted=true')) {
    document.querySelector('#contactPopup').classList.add('active');
  }
})